import { createAsyncAction } from 'typesafe-actions';

import generateLogger from '@travel/logger';

import { fetchVacancyCalendarDates as fetchVCDataAPI } from './apis';

import { getUserIdentifier } from 'store/common/selectors';

import type { AppThunk } from 'typesafe-actions';
import type {
  RequestBody,
  VacancyCalendarErrors,
  VacancyCalendarResponse,
} from 'VacancyCalendar-Types';

const logger = generateLogger();

export const fetchVacancyCalendarDataAsync = createAsyncAction(
  'FETCH_VACANCY_CALENDAR_REQUEST',
  'FETCH_VACANCY_CALENDAR_SUCCESS',
  'FETCH_VACANCY_CALENDAR_FAILURE',
)<undefined, VacancyCalendarResponse, VacancyCalendarErrors>();

export const fetchVacancyCalendarDates =
  (query: RequestBody): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    try {
      dispatch(fetchVacancyCalendarDataAsync.request());
      const userIdentifier = getUserIdentifier(getState());

      const response = await fetchVCDataAPI(apiClient, { ...query, rzCookie: userIdentifier });
      dispatch(fetchVacancyCalendarDataAsync.success(response));
    } catch (error) {
      dispatch(fetchVacancyCalendarDataAsync.failure(error as VacancyCalendarErrors));
      logger.error(error);
    }
  };
